// extracted by mini-css-extract-plugin
export var cardHeader = "_h4-1";
export var contentCard = "_h4-0";
export var headerActions = "_h4-3";
export var reorderHandle = "_h4-5";
export var titleArea = "_h4-2";
export var titleAreaWithHandle = "_h4-4";